import React from 'react'

import classNames from 'classnames'
import {
	AddComponentProps,
	PolymorphicReactComponentWithRef,
} from 'symbiosis-uikit/dist/utils'

import styles from './IconButton.pcss'

interface Props {
	icon: SVGRComponent
}

export const IconButton = React.forwardRef<
	HTMLButtonElement,
	AddComponentProps<Props, 'button'>
>(function IconButton(
	{ as, className, icon: Icon, ...props },
	ref
): JSX.Element {
	const Component = as || 'button'

	return (
		<Component
			className={classNames(styles.container, className)}
			ref={ref}
			{...props}
		>
			<Icon />
		</Component>
	)
}) as PolymorphicReactComponentWithRef<Props, 'button'>
